import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { injectIntl, intlShape } from 'react-intl';

import { getTotalUnreadMessageCountNotInActiveSession } from '../../app/ChatApp/selectors';
import styles from './styles';
import messages from './messages';

class ChatConversationHeaderUnread extends PureComponent {
  render() {
    const { unreadMessageCount, intl } = this.props;

    if (unreadMessageCount === 0) return null;

    return (
      <div
        aria-live="polite"
        aria-label={intl.formatMessage(messages.aria_label_unread_messages, { unreadMessageCount })}
        className="conversationUnreadIcon"
        style={styles.unread}
      >
        {unreadMessageCount}
      </div>
    );
  }
}

ChatConversationHeaderUnread.propTypes = {
  unreadMessageCount: PropTypes.number,
  intl: intlShape.isRequired,
};
ChatConversationHeaderUnread.defaultProps = {
  unreadMessageCount: 0,
};

export const mapStateToProps = state => ({
  unreadMessageCount: getTotalUnreadMessageCountNotInActiveSession(state),
});

const intlComponent = injectIntl(Radium(ChatConversationHeaderUnread), { withRef: true });
export default connect(mapStateToProps)(intlComponent);
